import React from "react";
import classnames from "classnames";
import { getPremiumMap, formatPremiumPrice } from "lib/premium-helpers";
import { usePremiumPlanPrices } from "lib/hooks/premiumHooks";

const { pricePerMap, termMap } = getPremiumMap();

export const NoPlan = (props) => {
  return (
    <div className="boost-plan plan_none">
      <div className="term">
        <span>NO</span>
        <span>CURRENT</span>
        <span>PLAN</span>
        <img src="https://static.bigbrain.gg/assets/ugg/boost/premium-draven.png" />
      </div>
    </div>
  );
};

export const FreeTrial = (props) => {
  const { billingAmount } = props;

  return (
    <div className="boost-plan plan_trial">
      <div className="term">
        <div className="plan-type free-trial">FREE TRIAL</div>
      </div>
    </div>
  );
};

export const BoostPlan = (props) => {
  const {
    plan,
    isSale,
    inputMode,
    isSelected,
    setPlan,
    textCenter,
    billingAmount,
    subtotal,
    displayDiscount,
    details,
    planCTA,
    planDuration,
  } = props;

  const { pricesByDuration } = usePremiumPlanPrices();

  const selectPlan = () => {
    setPlan(planDuration);
  };

  const planClassNames = classnames({
    "boost-plan": true,
    plan_month: plan === "basic_premium-1-month",
    plan_year: plan === "basic_premium-12-month",
    "_has-hover": inputMode,
    "_text-center": textCenter,
  });

  const termClassNames = classnames({
    term: true,
    discounted: displayDiscount,
  });

  let planPrice = planDuration && pricesByDuration && formatPremiumPrice(pricesByDuration[planDuration]);

  return (
    <div className={planClassNames} onClick={inputMode && selectPlan}>
      {inputMode && (
        <div className="plan-input-container">
          <div className="plan-radio-button-container">
            <input type="radio" className="radio-button" checked={isSelected} readOnly />
          </div>
        </div>
      )}
      <div className={termClassNames}>
        <div className="plan-type">{termMap[plan]}</div>
        <div className="price">
          {displayDiscount && (
            <span>
              <strong className={"discounted-subtotal"}>{subtotal}</strong>{" "}
            </span>
          )}
          <strong>{billingAmount || planPrice}</strong>
          <span className="text-lavender-300"> / </span>
          <span>{pricePerMap[plan]}</span>
          {planCTA}
        </div>
        {details && <div className={"details"}>{details}</div>}
      </div>
      {isSale && <img className="sale-tag" src="https://static.bigbrain.gg/assets/ugg/boost/save.svg" />}
    </div>
  );
};
